import { getEffectiveBcp47Locale } from './locale';

let localePatchesApplied = false;

export function applyLocaleAwareIntlDefaults(): void {
  if (localePatchesApplied || typeof window === 'undefined') {
    return;
  }

  localePatchesApplied = true;

  const originalDateToLocaleString = Date.prototype.toLocaleString;
  const originalDateToLocaleDateString = Date.prototype.toLocaleDateString;
  const originalDateToLocaleTimeString = Date.prototype.toLocaleTimeString;
  const originalNumberToLocaleString = Number.prototype.toLocaleString;
  const originalStringLocaleCompare = String.prototype.localeCompare;

  Date.prototype.toLocaleString = function toLocaleStringPatched(locales?: string | string[], options?: Intl.DateTimeFormatOptions): string {
    return originalDateToLocaleString.call(this, locales || getEffectiveBcp47Locale(), options);
  };

  Date.prototype.toLocaleDateString = function toLocaleDateStringPatched(locales?: string | string[], options?: Intl.DateTimeFormatOptions): string {
    return originalDateToLocaleDateString.call(this, locales || getEffectiveBcp47Locale(), options);
  };

  Date.prototype.toLocaleTimeString = function toLocaleTimeStringPatched(locales?: string | string[], options?: Intl.DateTimeFormatOptions): string {
    return originalDateToLocaleTimeString.call(this, locales || getEffectiveBcp47Locale(), options);
  };

  Number.prototype.toLocaleString = function toLocaleStringPatched(locales?: string | string[], options?: Intl.NumberFormatOptions): string {
    return originalNumberToLocaleString.call(this, locales || getEffectiveBcp47Locale(), options);
  };

  String.prototype.localeCompare = function localeComparePatched(compareString: string, locales?: string | string[], options?: Intl.CollatorOptions): number {
    return originalStringLocaleCompare.call(this, compareString, locales || getEffectiveBcp47Locale(), options);
  };
}
